import ls from "local-storage";

export const getRoleNamesFromUser = (user) => {
  if (!user || !Array.isArray(user.roles)) {
    return [];
  }

  return user.roles
    .map((role) => role?.name)
    .filter((roleName) => typeof roleName === "string" && roleName.trim() !== "");
};

export const getPrimaryRoleFromUser = (user) => getRoleNamesFromUser(user)[0] || "";

export const persistStoredRole = (role) => {
  const normalizedRole =
    typeof role === "string" && role.trim() !== "" ? role : false;

  ls.set("roles", normalizedRole);

  if (typeof window !== "undefined") {
    if (normalizedRole) {
      window.localStorage.setItem("roles", normalizedRole);
    } else {
      window.localStorage.removeItem("roles");
    }
  }

  return normalizedRole;
};

export const persistStoredUser = (user) => {
  ls.set("user", user || false);
  return user || false;
};

export const syncRoleToggleEligibility = ({ user, role } = {}) => {
  const roleNames = getRoleNamesFromUser(user);
  const currentEligibility = ls.get("roleToggleEligible") === true;
  const nextEligibility =
    currentEligibility ||
    role === "Super Admin" ||
    roleNames.includes("Super Admin") ||
    Number(user?.is_role_toggled) === 1;

  ls.set("roleToggleEligible", nextEligibility);

  if (typeof window !== "undefined") {
    window.localStorage.setItem("roleToggleEligible", String(nextEligibility));
  }

  return nextEligibility;
};

export const canCurrentUserToggleRole = ({ user, role } = {}) => {
  const roleNames = getRoleNamesFromUser(user);

  return (
    ls.get("roleToggleEligible") === true ||
    role === "Super Admin" ||
    roleNames.includes("Super Admin") ||
    Number(user?.is_role_toggled) === 1
  );
};
